import { FINANCE_RECORDS, MARKET_RECORDS } from './recordsFinance'
import { POLICY_AND_INTERNATIONAL_RECORDS } from './recordsInternational'
import { REGULATORY_RECORDS } from './recordsClimate'
import type { RegulatoryRecord } from './types'

export const PUBLISHED_RECORDS: RegulatoryRecord[] = [
  ...REGULATORY_RECORDS,
  ...FINANCE_RECORDS,
  ...MARKET_RECORDS,
  ...POLICY_AND_INTERNATIONAL_RECORDS,
]

const byId = new Map(PUBLISHED_RECORDS.map((record) => [record.id, record]))
const bySlug = new Map(PUBLISHED_RECORDS.map((record) => [record.slug, record]))

export function getRecordById(id: string): RegulatoryRecord | undefined {
  return byId.get(id)
}

export function getRecordBySlug(slug: string): RegulatoryRecord | undefined {
  return bySlug.get(slug)
}

export function publishedSlugs(): string[] {
  return PUBLISHED_RECORDS.map((record) => record.slug)
}
